import { styled } from "src/stitches"

export const Accelerate = styled("div", {
  transform: "translate3d(0,0,0)",
  backfaceVisibility: "hidden",
  contentVisibility: "auto",
})
